// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".display-none[data-v-d8f4a95c]{display:none}.menu-item-prefix[data-v-d8f4a95c]{margin-right:15px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
